export default __webpack_public_path__ + "static/media/suppliers.a214f285.jpg";